import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledAccessBanner = styled(FlexRow)`
    display: flex;
    width: 100%;
    background: ${colorsPalettes.sky["100"]};
    padding: 12px;
`;

export const StyledIconWrapper = styled.div`
    display: flex;
    margin-right: 8px;
    width: 24px;
    height: 24px;

    img {
        max-width: fit-content;
        width: 24px;
        height: 24px;
    }
`;

export const StyledBannerContent = styled(FlexColumn)``;

export const StyledBannerContentTitle = styled.div`
    display: flex;
    ${mixins.setFontVariant("subtitle1", colorsPalettes.indigo["300"])};
    margin-bottom: 4px;
`;

export const StyledBannerContentDescription = styled.div`
    display: flex;
    ${mixins.setFontVariant("body2", colorsPalettes.indigo["300"])};
    margin-bottom: 12px;
`;

export const StyledBannerBtnWrapper = styled.div`
    display: flex;
`;

export const StyledSuccessIconWrapper = styled.div`
    width: 120px;
    height: 100px;
    & > svg {
        width: 120px;
        height: 100px;
    }
`;

export const StyledSuccessContainer = styled.div`
    display: flex;
    padding: 24px 20px;
    gap: 12px;
    align-items: center;
    justify-content: flex-start;
    background: ${colorsPalettes.bluegrey["100"]};
    height: 138px;
    overflow: hidden;
`;
